<div *ngIf="ProfilAuthorise">
    <div class="mx-5 d-flex flex-column" style="height: 100%;">
        <button class="btn btn-sm btn-primary my-2 align-self-start" type="button" (click)="toggleDisplayFilters()">
            <span [hidden]="visibleFilters">
                <paflabel lblCod="Filtres_de_recherche"></paflabel>&nbsp;<i class="fas fa-search"></i>
            </span>
            <span [hidden]="!visibleFilters">
                <paflabel lblCod="Masquer_les_filtres"></paflabel>&nbsp;<i class="far fa-caret-square-up"></i>
            </span>
        </button>
    </div>

    <div class="card bg-light shadow-sm" [hidden]="!visibleFilters">
        <div class="card-body">
            <form name="frmListDocuments" #ngFrmListDocuments="ngForm">
                <div class="row">
                    <div class="col-4">
                        <div class="form-group">
                            <label class="control-label">Nom du fournisseur</label> <small><label
                                    class="control-label">(Contient)</label></small>
                            <input type="text" class="form-control" name="SupplierName"
                                [(ngModel)]="filters.SupplierName">
                        </div>
                    </div>
                    <div class="col-4">
                        <label class="control-label">Segment/famille/Sous-famille</label>
                        <div class="flex-fill " style="min-width: 350px;max-width:500px;">
                            <kendo-multiselect class="form-control" name="FamiliesIds" [data]="lstFamiliesFiltered"
                                [filterable]="true" (filterChange)="LstFamiliesFilterChange($event)" [(ngModel)]="selectedFamilies" textField="Display" valueField="Id"
                                #lstFamiliesCbo>
                                <ng-template kendoMultiSelectTagTemplate let-dataItem>
                                    <span class="template" [ngClass]="familyClass(dataItem)">{{ dataItem.Display
                                        }}</span>
                                </ng-template>
                                <ng-template kendoMultiSelectItemTemplate let-dataItem>
                                    <div style="width:100%;" [ngClass]="familyClass(dataItem,true)"
                                        [innerHTML]="highlightSearch(dataItem.Display,familySearchMask)"></div>
                                </ng-template>
                            </kendo-multiselect>
                        </div>
                    </div>
                    <div class="col-4">
                        <label class="control-label">Montant total facturé</label> <small><label
                                class="control-label">(sur
                                12 mois)</label></small>
                        <div class="d-flex">
                            <label class="control-label mr-1">Entre</label>
                            <input type="number" class="form-control" min="0" [(ngModel)]="filters.MntFacMin"
                                name="MntFacMin">
                            <label class="control-label mx-1">€</label>
                            <label class="control-label mx-1">et</label>
                            <input type="number" class="form-control" min="0" [(ngModel)]="filters.MntFacMax"
                                name="MntFacMax">
                            <label class="control-label ml-1">€</label>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-2">
                        <div class="form-group">
                            <label class="control-label" paflabel="Type_de_document"></label>
                            <kendo-multiselect class="form-control" name="selectedDocTyps" [data]="lstDocTyps"
                                [(ngModel)]="selectedDocTyps" textField="Display" valueField="Id">
                            </kendo-multiselect>
                        </div>
                    </div>
                    <div class="col-3">
                        <div class="form-group">
                            <label class="control-label" paflabel="Document"></label>
                            <kendo-multiselect class="form-control" name="selectedPafDocuments"
                                [data]="filteredPafDocuments" [(ngModel)]="selectedPafDocuments" textField="Display"
                                valueField="Id">
                            </kendo-multiselect>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label class="control-label" paflabel="Statut"></label>
                            <kendo-multiselect class="form-control" name="DocStatutIds" [data]="lstDocStatuts"
                                [(ngModel)]="selectedDocStatuts" textField="Display" valueField="Id">
                            </kendo-multiselect>
                        </div>
                    </div>
                    <div class="col-2">
                        <paf-combobox 
                            headerPafLabel="Pays"
                            [(ngModel)]="country"  
                            name="selectedCountry" 
                            [data]="sharedDataSvc.countries"
                            style="width:100%;">
                        </paf-combobox>
                    </div>
                    <div class="col-3">
                        <label class="control-label" paflabel="Forme_juridique"></label>
                        <kendo-combobox 
                            #lstLegalForms 
                            name="lstLegalForms" 
                            [data]="countryLegalForms"
                            textField="LblCod" 
                            valueField="Id" 
                            [valuePrimitive]="true" 
                            [(ngModel)]="filters.LegalFormId" 
                            style="width:100%;">
                        </kendo-combobox>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <label class="control-label">Date d'expiration</label>
                        <div class="d-flex">
                            <label class="control-label">Du</label>
                            <kendo-datepicker name="DateExpiDeb" [(ngModel)]="filters.DateExpiDeb" allowInput="true"></kendo-datepicker>
                            <label class="ml-2 control-label">au</label>
                            <kendo-datepicker name="DateExpiFin" [(ngModel)]="filters.DateExpiFin" allowInput="true"></kendo-datepicker>
                        </div>
                    </div>
                    <div class="col-4">
                        <label class="control-label">Date de document</label>
                        <div class="d-flex">
                            <label class="control-label">Du</label>
                            <kendo-datepicker name="DateDocDeb" [(ngModel)]="filters.DateDocDeb" allowInput="true"></kendo-datepicker>
                            <label class="ml-2 control-label">au</label>
                            <kendo-datepicker name="DateDocFin" [(ngModel)]="filters.DateDocFin" allowInput="true"></kendo-datepicker>
                        </div>
                    </div>
                    <div class="col-2">
                        <div class="form-group">
                            <label class="control-label" paflabel="Etat_du_dossier"></label>
                            <kendo-combobox #lstEtatDoc name="lstEtatDoc" [data]="lstEtatDocumentaire"
                                [(ngModel)]="filters.EtatDossier" style="width:100%;">
                            </kendo-combobox>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center mt-2">
                        <button class="btn btn-primary mx-2" type="commit" (click)="search()"><i
                                class="fas fa-search mr-1"></i>Rechercher</button>
                        <button class="btn btn-success mx-2" type="button" (click)="grid.saveAsExcel()" [disabled]="documents.length==0"><i
                                class="far fa-file-excel mr-1"></i>Exporter</button>
                        <button class="btn btn-danger mx-2" type="button" (click)="reinit()"><i
                                class="fas fa-ban mr-1"></i>Réinitialiser</button>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <div class="card">
        <div class="card-body">
            <kendo-grid id="lst-documents-grid" #grid="kendoGrid" [data]="gridData" [pageSize]="state.take"
                [skip]="state.skip" [sort]="state.sort" [filter]="state.filter" [sortable]="true"
                [pageable]="gridPageableSettings" [filterable]="'menu'" [height]="600" [reorderable]="true"
                (filterChange)="filterChange($event)" (dataStateChange)="dataStateChange($event)">
                <kendo-grid-messages filterIsFalse="Non&nbsp;&nbsp;" filterIsTrue="Oui&nbsp;&nbsp;">
                </kendo-grid-messages>
                <kendo-grid-column *ngIf="ValidationColumnVisible" field="CanValidate" title="" [width]="50" [filterable]="false" [sortable]="false"
                    [locked]="true">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div class="d-flex align-items-center justify-content-around">
                            <button [hidden]="dataItem.TopConforme==1 || dataItem.CanValidate==0" type="button"
                                class="btn btn-xs btn-success ml-1" (click)="validateDoc(dataItem)"
                                paftooltip="Valider_le_document"><i class="fas fa-clipboard-check"></i>
                            </button>
                            <button [hidden]="dataItem.TopNonConforme==1 || dataItem.CanValidate==0" type="button"
                                class="btn btn-xs btn-danger mx-1" (click)="unvalidateDoc(dataItem)"
                                paftooltip="Rejeter_le_document"><i class="fas fa-ban"></i>
                            </button>
                            <span *ngIf="dataItem.StatutId==10" [ngClass]="docCssTxtStatut(dataItem)"><i
                                    class="fas fa-archive"></i></span>
                        </div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column *ngIf="sharedDataSvc.debug" field="DocId" title="DocId" [width]="80" filter="numeric"
                    [locked]="true"></kendo-grid-column>
                <kendo-grid-column *ngIf="sharedDataSvc.debug" field="SupplierId" title="SupplierId" [width]="110"
                    filter="numeric" [locked]="true"></kendo-grid-column>
                <kendo-grid-column field="DocTypLib" title="Type de document" [width]="180"></kendo-grid-column>
                <kendo-grid-column field="RefDocLib" title="Document" [width]="300">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a class="control-label" *ngIf="dataItem.FullPath" href="javascript:void(0);"
                            (click)="btnDownloadFileClick(dataItem)"
                            [paftooltip]="'Telecharger_le_fichier'">{{dataItem.RefDocLib}}</a>
                        <span *ngIf="!dataItem.FullPath">{{dataItem.RefDocLib}}</span>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="DocDate" title="Date du document" [width]="120"
                    [format]="{ date: 'dd/MM/yyyy' }" filter="date"></kendo-grid-column>
                <kendo-grid-column field="DocDateExpi" title="Expire le" [width]="120" [format]="{ date: 'dd/MM/yyyy' }"
                    filter="date">
                </kendo-grid-column>
                <kendo-grid-column field="SupplierName" title="Fournisseur" [width]="300">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a class="control-label" [routerLink]="getSupplierLink(dataItem)"
                            [paftooltip]="'Fiche_fournisseur'">
                            {{ dataItem.SupplierName }}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="StatutLib" title="Statut" [width]="150">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <span style="font-size:16px;width:100%; text-align: center;"><label
                                [ngClass]="docCssBadgeStatut(dataItem)">{{dataItem.StatutLib}}</label></span>
                    </ng-template>
                </kendo-grid-column>

                
                <kendo-grid-column field="ContratCadreCommentaires" title="Description" [width]="320"></kendo-grid-column>
                <kendo-grid-column field="CoeurDeMetier" title="Coeur de métier" [width]="150"></kendo-grid-column>

                <kendo-grid-column field="CtrlDate" title="Vérifié le" [width]="120" [format]="{ date: 'dd/MM/yyyy' }"
                    filter="date">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <label [ngClass]="docCssTxtStatut(dataItem)">{{dataItem.CtrlDate | date:'dd/MM/yyyy'}}</label>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="CreaDate" title="Déposé le" [width]="120" [format]="{ date: 'dd/MM/yyyy' }"
                    filter="date"></kendo-grid-column>
                <kendo-grid-column field="CreaMail" title="Par" [width]="300"></kendo-grid-column>
                <kendo-grid-column field="Numtiers" title="Tiers" [width]="120">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a class="control-label" [routerLink]="getSupplierLink(dataItem)"
                            [paftooltip]="'Fiche_fournisseur'">
                            {{ dataItem.Numtiers }}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="Filename" title="Nom du fichier" [width]="320">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <a class="control-label" *ngIf="dataItem.FullPath" href="javascript:void(0);"
                            (click)="btnDownloadFileClick(dataItem)"
                            [paftooltip]="'Telecharger_le_fichier'">{{dataItem.Filename}}</a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="dossierComplet" title="Dossier complet" [width]="120" filter="boolean">
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <div style="text-align: center;"><i [ngClass]="checkNgClass(dataItem.dossierComplet)"></i></div>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="DateRelanceM20" title="Date relance frs - 3" [width]="120"
                    [format]="{ date: 'dd/MM/yyyy' }" filter="date"></kendo-grid-column>
                <kendo-grid-column field="DateRelanceM10" title="Date relance frs - 2" [width]="120"
                    [format]="{ date: 'dd/MM/yyyy' }" filter="date"></kendo-grid-column>
                <kendo-grid-column field="DateRelanceM5" title="Date relance frs - 1" [width]="120"
                    [format]="{ date: 'dd/MM/yyyy' }" filter="date"></kendo-grid-column>
                <kendo-grid-column field="DateRelanceJ" title="Echéance" [width]="120" [format]="{ date: 'dd/MM/yyyy' }"
                    filter="date"></kendo-grid-column>
                <kendo-grid-column field="DateRelanceJ10" title="Date relance frs + 1" [width]="120"
                    [format]="{ date: 'dd/MM/yyyy' }" filter="date"></kendo-grid-column>
                <kendo-grid-column field="DateRelanceJ20" title="Date relance frs + 2" [width]="120"
                    [format]="{ date: 'dd/MM/yyyy' }" filter="date"></kendo-grid-column>
                <kendo-grid-column field="DateRelanceJ30" title="Date relance frs + 3" [width]="120"
                    [format]="{ date: 'dd/MM/yyyy' }" filter="date"></kendo-grid-column>
                <kendo-grid-excel fileName="ListeDocumentaire.xlsx" [fetchData]="allData">
                    <kendo-excelexport-column field="DocTypLib" title="Type de document"></kendo-excelexport-column>
                    <kendo-excelexport-column field="RefDocLib" title="Document"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DocDate"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Date de document"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DocDateExpi"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Date d'expiration"></kendo-excelexport-column>
                    <kendo-excelexport-column field="SupplierName" title="Fournisseur"></kendo-excelexport-column>
                    <kendo-excelexport-column field="StatutLib" title="Statut"></kendo-excelexport-column>
                    <kendo-excelexport-column field="ContratCadreCommentaires" title="Description"></kendo-excelexport-column>
                    <kendo-excelexport-column field="CoeurDeMetier" title="Coeur de métier"></kendo-excelexport-column>
                    <kendo-excelexport-column field="CtrlDate" title="Vérifié le" [width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}"></kendo-excelexport-column>
                    <kendo-excelexport-column field="CreaDate" [width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Déposé le"></kendo-excelexport-column>
                    <kendo-excelexport-column field="CreaMail" title="Déposé par"></kendo-excelexport-column>
                    <kendo-excelexport-column field="Numtiers" title="Tiers"></kendo-excelexport-column>
                    <kendo-excelexport-column field="Filename" title="Nom du fichier"></kendo-excelexport-column>
                    <kendo-excelexport-column field="EtatDossier" title="Etat dossier documentaire"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DateRelanceM20"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Date relance frs - 3"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DateRelanceM10"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Date relance frs - 2"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DateRelanceM5"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Date relance frs - 1"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DateRelanceJ"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Echéance"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DateRelance10"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Date relance frs + 1"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DateRelance20"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Date relance frs + 2"></kendo-excelexport-column>
                    <kendo-excelexport-column field="DateRelance30"[width]="80"  [cellOptions]="{format:'dd/mm/yyyy'}" title="Date relance frs + 3"></kendo-excelexport-column>
                </kendo-grid-excel>
            </kendo-grid>
        </div>

    </div>
</div>
<div class="row" *ngIf="!sharedDataSvc.allListLoadingsInProgress && !ProfilAuthorise">
    <div class="col-4 offset-4">
        <div class="card my-5">
            <div class=" card-body bg-danger">
                <H3>Votre profil n'est pas autorisé sur cet écran.</H3>
            </div>
        </div>
    </div>
</div>
